// extracted by mini-css-extract-plugin
export default {"layout":"Post_layout__VqMi9"};